import { render, staticRenderFns } from "./SecondSection.vue?vue&type=template&id=e1076d12&"
import script from "./SecondSection.vue?vue&type=script&lang=ts&"
export * from "./SecondSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports